export default __webpack_public_path__ + "static/media/file-list-3-line.42d67546.svg";